<div *ngIf="isLoading$ | async" class="custom-spinner">
    <div class="d-flex flex-column align-items-center justify-content-center custom-div">
        <img src="../../../assets/logo-prody.gif" alt="loading..." class="logo">
        <span class="fs-16px text-white"><b>{{mensaje$ | async}}</b></span>
    </div>
</div>